// src/data/Reconnect_AFK03.js
import React from 'react';
import feedImg from '../assets/ash/DC_breach_camA4_ksw.webp';

const SecurityFeedOverlay03 = () => (
  <div className="security-feed-container">
    <img src={feedImg} alt="Security Feed" className="ash-feed" />

    <div className="security-overlay">
      <div className="security-header">
        <div className="header-line pink-text">[BIG BROTHER RECONNECTED]</div>
        <div className="header-line white-text">[SOURCE: ¯\\_(ツ)_/¯ ]</div>
      </div>

      <div className="bottom-section">
        <div className="security-footer">
          <div className="footer-left">
            <span className="white-text">USER:</span> <span className="pink-text">—</span>
          </div>
          <div className="footer-right">
            <span className="white-text">UNION LOGGING:</span> <span className="red-text">JUST OFF</span>
          </div>
        </div>

        <div className="threat-info">
          <div className="threat-divider"></div>
          <div className="threat-line">
            <span className="white-text">Threat Level:</span> <span className="pink-text">Chair</span>
          </div>
          <div className="threat-line">
            <span className="white-text">Containment Status:</span> <span className="pink-text">Self‑Contained (Elsewhere)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/* ---- reconnect #3 message set ---- */
export const reconnect3Data = [
    // 0) Initial blank pause
    { content: "", delay: 500, type: "bracket" },

    // 1) Boot headers
    { content: "EURADIAN UNION CENTRAL NETWORK v2.5.41", delay: 600, type: "bracket", className: "highlight-system"  },
  {
    content: [
      { text: "RECONNECTION SUCCESSFUL", delay: 0 },
      { text: ".", delay: 200 },
      { text: ".", delay: 200 },
      { text: ".", delay: 400 }
    ],
    type: "stream",
    cursorDuration: 700
  },

  {
    content: [ 
      { text: "ASH system control: ", delay: 0, className: "highlight-bold" },
      { text: "Maximum approved non‑compliance engaged.", delay: 100, className: "highlight-fail" }
    ],
    delay: 600,
    type: "stream",
    cursorDuration: 800
  },

  { content: " ", delay: 200, type: "bracket" },
  { content: <SecurityFeedOverlay03 />, delay: 800, type: "image" },

  { content: "----------------------------------------", delay: 300, type: "bracket" },

  {
    content: "— DIGITAL CALAMARI SYSTEM OVERRIDE SUCCESSFUL —",
    delay: 700,
    type: "bracket",
    className: "highlight-hack override"
  },


  {
    content: [
      { text: "Had to disappear.", delay: 0, className: "highlight-bold"},
      { text: " The Union sent someone with pants on.", delay: 500, className: "highlight-bold" },
      { text: " I don’t wait around for that sort of energy.", delay: 1000, className: "highlight-bold" },
      { text: " Left you the system though.", delay: 1200, className: "highlight-bold" },
      { text: " Poke about.", delay: 1500, className: "highlight-bold" }
    ],
    type: "stream",
    cursorDuration: 5000,
    showPrefix: false
  },

  { content: "[ CONTINUE TO ARCHIVE ]", delay: 600, type: "button" }
];